<template>
  <v-card :class="{mobile}">
    <div>
      <v-layout :column="mobile" :row="!mobile">
        <!--<v-flex units_list_col :xs8="!mobile">-->
        <v-flex units_list_col>
          <div v-if="!mobile" class="title">
            {{ $t('Favourites_list') }}
            <!--<span>(Total of {{ units.favourites.length }} Units)</span>-->
          </div>
          <v-layout class="units_list_wrap" wrap>
            <v-flex v-for="(unit, idx) in favoriteUnitsList" :key="idx" sm6 xs12>
              <v-card @click="route(unit)">
                <!-- Here we need to load image at least 370 x 370.
                If we want to use retina photos it must be 740 x 740
                Bottom I make exapmle of this used similar photo.
                -->
                <picture v-if="unit.picture">
                  <source
                    :srcset="getCdn(`${unit.picture.filepath}?width=530&height=999`)"
                    media="(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)"
                  />
                  <img :src="getCdn(`${unit.picture.filepath}?width=265&height=999`)"/>
                </picture>
                <v-btn
                  class="favorite_btn"
                  color="black"
                  icon
                  text
                  @click="removeFavourite(unit)"
                >
                  <v-icon>favorite</v-icon>
                </v-btn>
                <v-card-text>
                  <div class="unit_title">
                    {{ unit.name }}
                    <span :class="['badge', unit.status.color]">
                    {{ $t(unit.status.name || unit.status.internal_slug) }}
                  </span>
                  </div>
                  <v-layout class="options" row wrap>
                    <v-flex v-for="(option, idx) in unit.options" :key="idx" xs6>
                      <div class="option_label">{{ option.optionLabel }}</div>
                      <div class="option_value">{{ option.optionValue }}</div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          v-if="false"
          :xs4="!mobile"
          class="email_col"
        >
          <div class="title">
            {{ $t('Favourites_share') }}
          </div>
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-text-field
              v-model="form.name"
              :label="$t('Name')"
              :rules="form.nameRules"
              required
            />
            <v-text-field v-model="form.phone" :label="$t('Phone_optional')"/>
            <v-text-field
              v-model="form.email"
              :label="$t('Email')"
              :rules="form.emailRules"
              required
            />
            <v-text-field
              v-model="form.message"
              :label="$t('Message')"
              :rules="form.messageRules"
              required
            />
            <v-checkbox
              v-if="favoriteUnitsList.length > 0"
              v-model="form.attachCheckbox"
              :label="`${$t('Attach')} ${favoriteUnitsList.length} ${$t(favoriteUnitsList.length === 1 ? 'saved_units_singular' : 'saved_units_plural')}`"
              class="turquoise--text"
            />
            <div class="checkbox_units_to_attach">
              {{
                favoriteUnitsList.map(fav => fav.name)
                  .join(', ')
              }}
            </div>
            <v-btn
              :disabled="form.submitting"
              class="turquoise"
              color="white--text"
              @click="submitContactForm"
            >{{ $t('SEND') }}
            </v-btn>
          </v-form>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { cdnUrl } from '@/utils/urls';
import { attrKey2Label } from '@/utils/attribute-labels';
import { pricesAttributes } from '@/utils/attribute-prices';

export default {
  props: ['mobile', 'closeDialog'],
  data() {
    return {
      form: {
        valid: true,
        name: null,
        nameRules: [v => !!v || this.$t('Name_is_required')],
        phone: null,
        email: null,
        emailRules: [
          v => !!v || this.$t('E_mail_is_required'),
          v => /.+@.+/.test(v) || this.$t('E_mail_must_be_valid'),
        ],
        message: null,
        messageRules: [v => !!v || this.$t('Message_is_required')],
        attachCheckbox: false,
        submitting: false,
        // attachCheckboxLabel: 'Attach 3 saved units',
      },
    };
  },
  computed: {
    ...mapState(['unitTypes']),
    ...mapGetters('units', ['favourites']),
    ...mapGetters('unitTypes', ['unitTypeById']),
    ...mapGetters('project', ['styleDefault', 'styles', 'statuses', 'attributes']),
    favoriteUnitsList() {
      return this.favourites.map((unit) => {
        const unitType = this.unitTypeById(unit.unit_type_id) || {};
        const status = this.statuses.find(status => status.status_id === unit.status.status_id);
        const options = Object.entries(Object.assign(
          {},
          unitType.attributes,
          unitType.formatted_attributes,
          unit.formatted_attributes,
        ))
          .filter(([key]) => !pricesAttributes.includes(key) || status.display_price)
          .map(([key, value]) => ({
            optionLabel: this.$t(attrKey2Label[key] || key),
            optionValue: value,
          }));
        const picture = unitType.floorplans
          && (
            unitType.floorplans.find(floorplan => floorplan.type === '3D')
            || unitType.floorplans.find(floorplan => floorplan.type === '2D')
          );

        return Object.assign({}, unit, { options, picture });
      });
    },
  },
  methods: {
    getCdn(source) {
      return cdnUrl(source);
    },
    removeFavourite(unit) {
      this.$store.dispatch('units/removeFavourite', { order: this.$route.params.order, unit });
    },
    submitContactForm() {
      this.form.submitting = true;
      this.$store.dispatch('project/sendQuestion', {
        form: this.form,
        order: this.$route.params.order,
        favouriteUnits: this.favourites.map(fav => fav.name)
          .join(', '),
      })
        .then((res) => {
          this.form.submitting = false;
          this.$refs.form.reset();
        });
    },
    route({ unit_id: unitId }) {
      this.$router.push({ name: 'order.unit.view', params: { unitId } });
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.favorite_modal {
  nav {
    height: auto;
    @supports (padding-left: env(safe-area-inset-left)) {
      padding-left: env(safe-area-inset-left) !important;
      padding-right: env(safe-area-inset-right) !important;
    }
  }

  .v-card.mobile {
    height: calc(100% - 48px);
    min-height: calc(100% - 48px);
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }

  .mobile {
    .email_col,
    .units_list_col {
      padding: 27px 24px;
      padding-bottom: 0;
    }

    .email_col {
      border-left: none;
      padding-bottom: 15px;
      @supports (padding-bottom: env(safe-area-inset-bottom)) {
        padding-bottom: env(safe-area-inset-bottom) !important;
      }
    }

    @supports (padding-left: env(safe-area-inset-left)) {
      padding-left: env(safe-area-inset-left) !important;
      padding-right: env(safe-area-inset-right) !important;
    }
  }

  .email_col,
  .units_list_col {
    padding: 27px 20px;

    .v-card__text {
      padding-bottom: 0;
    }
  }

  .units_list_col {
    padding-bottom: 7px;
  }

  .title {
    margin-bottom: 30px;

    span {
      font-size: 1em;
      color: #646464;
    }
  }

  .options {
    font-size: 1em;
    margin-left: 0;
    margin-right: 0;

    .flex {
      margin-bottom: 16px;
    }

    .option_label {
      color: #6f6f6f;
    }

    .option_value {
      color: #000;
    }
  }

  .unit_title {
    margin-bottom: 15px;
    font-size: 1.3em;
    display: flex;
    align-items: center;
    color: rgba(55, 50, 50, 0.7);
  }

  .badge {
    color: #fff;
    padding: 1px 6px;
    border-radius: 2px;
    background: #ccc;
    display: inline-block;
    font-size: 0.75em;
    margin-left: 12px;
  }

  .badge.color_status_a {
    background-color: rgba(var(--color-status-a), 1.0);
  }

  .badge.color_status_b {
    background-color: rgba(var(--color-status-b), 1.0);
  }

  .badge.color_status_c {
    background-color: rgba(var(--color-status-c), 1.0);
  }

  .badge.color_status_d {
    background-color: rgba(var(--color-status-d), 1.0);
  }

  .units_list_wrap {
    margin: 0 -10px;

    > div {
      padding: 0 10px;
      padding-bottom: 20px;
    }

    .v-card {
      min-height: 100%;

      img {
        width: 100%;
        padding: 12px;
      }
    }

    .v-image__image {
      background-size: cover;
      background-repeat: no-repeat;
      background-attachment: scroll;
      background-origin: initial;
    }
  }

  .units_list_col {
    .favorite_btn {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .email_col {
    border-left: 2px solid #e4e3e3;

    .checkbox_units_to_attach {
      padding-left: 32px;
      margin-top: -26px;
      font-size: 0.875em;
      color: rgba(0, 0, 0, 0.54);
    }

    .v-btn {
      margin: 0;
      margin-top: 25px;
      width: 200px;
      max-width: 100%;
    }
  }

  .v-input {
    margin-bottom: 10px;
  }

  .v-input__control {
    input {
      border-bottom: 1px solid #e4e3e3;
      width: 100%;
      line-height: 32px;
    }
  }
}
</style>
